import { render, staticRenderFns } from "./FieldKeywords.vue?vue&type=template&id=4adb9acf&"
import script from "./FieldKeywords.vue?vue&type=script&lang=js&"
export * from "./FieldKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports